export interface Profile {
  id: string;
  type: string;
  title: string;
  shortDescription: string;
  longDescription: string;
  image: string;
  youtubeVideoId: string;
  gumroadLink: string;
  heroImages: string;
  // Add any other properties that might exist in your profiles.json
  [key: string]: any;
}

export const defaultProfile: Profile = {
  id: "",
  type: "",
  title: "Profile Not Found",
  shortDescription: "This profile could not be found.",
  longDescription: "",
  image: "", // Consider a placeholder image path
  youtubeVideoId: "",
  gumroadLink: "",
  heroImages: "",
};
